// extracted by mini-css-extract-plugin
export var completionBody = "_e7-2";
export var completionCard = "_e7-0";
export var completionFooter = "_e7-3";
export var completionTitle = "_e7-1";